import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Maps, MapsTooltip, MapsComponent, ISelectionEventArgs, Selection, Highlight, MapsModule, MapsTooltipService, DataLabelService } from '@syncfusion/ej2-angular-maps';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { italyMap } from '../../../../../../shared/italy-regions';
import { NtPotentialRegionInterface } from '../../../../../../shared/interfaces/nt-potential-region.interface';
import { ModalInclusionPerRegComponent } from '../modal-inclusion-per-reg/modal-inclusion-per-reg.component';
import { CommonModule } from '@angular/common';
import { NtOpenToAccessMapInterface } from '../../../../../../shared/interfaces/nt-openToAccess-map-interface';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { TimelineEvolutionRegionalAccess } from '../../../../../../shared/interfaces/nt-EvolutionRegionalAccess.interface';

Maps.Inject(MapsTooltip, Selection, Highlight);

@Component({
  selector: 'app-map-open-to-access-regions',
  imports: [MapsModule, CommonModule],
  providers: [MapsTooltipService, DataLabelService],
  templateUrl: './map-open-to-access-regions.component.html',
  styleUrl: './map-open-to-access-regions.component.css'
})
export class MapOpenToAccessRegionsComponent {
  @ViewChild(MapsComponent) public maps?: MapsComponent;

  public mapWidth: string = '98%';
  public mapHeight: string = '98%';

  public medicineId: number = 0;
  public companyId: number = 0;
  public countryId: number = 1;
  public regionId: number = 0;
  public regionName?: string | null;
  dataFromRegionalAccessEvolution: TimelineEvolutionRegionalAccess[] =[]
  public isModalInclusioneActive: boolean = false;

  public layers?: object[];

  dataFromRegions: NtOpenToAccessMapInterface[] = [];

  @Input() heatmapColorStatus: 'Red' | 'White' = 'Red';

  constructor(private dataService: DataService, private us: DmtUtilityService) { }


  
 ngOnInit(): void {
    this.layers = [
      {
        shapeData: italyMap
      }
    ];

    this.getSessionVariables();

    this.dataService.getRegionalAccessEvolutionData(this.companyId, this.medicineId, this.countryId).subscribe(data => {
      this.dataFromRegionalAccessEvolution = data;
      
      this.dataService.getHeatmapRegionalAccessData(this.medicineId, this.countryId).subscribe({
        next: (data: NtOpenToAccessMapInterface[]) => {
           this.dataFromRegions = data; 
        this.loadData(data); 
        },
        error: (error) => {
          console.error('Errore nel recupero dei dati della mappa regionale:', error);
        }
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
  if (changes['heatmapColorStatus'] && !changes['heatmapColorStatus'].firstChange) {
    if (this.dataFromRegions.length > 0) {
      this.loadData(this.dataFromRegions);
      
      setTimeout(() => {
        if (this.maps) {
          this.maps.refresh();
        }
      }, 100);
    }
  }
}

  loadData(regions: NtOpenToAccessMapInterface[]): void {
    const regioniHeatmapData = regions.map(item => {
      let statusText = 'Chiusura';
      let isCompleted = false;
      
      if (this.dataFromRegionalAccessEvolution && this.dataFromRegionalAccessEvolution.length > 0) {
        for (const dateData of this.dataFromRegionalAccessEvolution) {
          if (dateData.actual && dateData.actual.includes(item.regionName)) {
             const dateParts = dateData.datePoint.split('-');
          const formattedDate = dateParts.length === 2 ? `${dateParts[1]} / ${dateParts[0]}` : dateData.datePoint;   
          statusText = `${formattedDate}`;
            isCompleted = true;
            break;
          }
        }
      } else {
        isCompleted = item.isCompleted === true;
        statusText = isCompleted ? 'Apertura' : 'Chiusura';
      }

      const formattedRegionName = item.regionName === 'Prov. Aut. di Bolzano' ? 'PA di Bolzano' :
                                 item.regionName === 'Prov. Aut. di Trento' ? 'PA di Trento' :
                                 item.regionName;

      return {
        regionId: item.regionId,
        regionName: item.regionName,
        isCompleted: isCompleted,
        tooltipText: `${formattedRegionName}: <br> ${statusText}`
      };
    });

    this.layers = [
      {
        shapeData: italyMap,
        shapePropertyPath: 'id',
        shapeDataPath: 'regionId',
        dataSource: regioniHeatmapData,
        tooltipSettings: {
          visible: true,
          valuePath: 'tooltipText',
          textStyle: {
            size: '10px',
          },
        },
        highlightSettings: {
          enable: false,
          fill: '#00CEBC'
        },
        selectionSettings: {
          enable: false,
          fill: '',
          opacity: 1,
        },
shapeSettings: {
  border: {
    color: this.heatmapColorStatus === 'White' ? '#162456' : '#FFFFFF',
    width: this.heatmapColorStatus === 'White' ? 0.7 : 0.4,
  },
  borderWidth: this.heatmapColorStatus === 'White' ? 0.5 : 4,
          colorValuePath: 'isCompleted',
          colorMapping: [
            {
              value: true,
              color: '#008236'
            },
            {
              value: false,
               color: this.heatmapColorStatus === 'Red' ? '#C10007' : '#FFFFFF' 
            }
          ]
        }
      }
    ];
  }
  public itemSelection = (args: ISelectionEventArgs) => {
    if (args.shapeData !== isNullOrUndefined) {
      this.isModalInclusioneActive = true;
      this.regionId = Number((args.data as NtPotentialRegionInterface).regionId)
      this.regionName = (args.data as NtPotentialRegionInterface).regionName
    }
  };

  showModalInclusione (value: boolean) {
    this.isModalInclusioneActive = value;
  }

    getSessionVariables() {
    this.regionName = sessionStorage.getItem('regionName') || '';
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
    this.regionId = this.us.getSessionVariableNumber('regionId');
    this.companyId = this.us.getSessionVariableNumber('companyId', 0);
  }
}
